export const routes = {
  getProfile: () => `/kindergarten/profile/detail`,
};
